import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    TYPING_SEND: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },

  'TYPING_SEND_SUCCEEDED',
  'TYPING_SEND_FAILED',

  'TYPING_ADD',
  'TYPING_REMOVE',
);
